import { createContext, useContext } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store/store";

interface PayerNameContextFromSingleOrderLayoutProps {
  payerName: string;
  setPayerName: (payerName: string) => void;
}

export const PayerNameContextFromSingleOrderLayout =
  createContext<PayerNameContextFromSingleOrderLayoutProps>({
    payerName: "",
    setPayerName: () => {},
  });

export const usePayerNameContextFromSingleOrderLayout = () => {
  const context = useContext(PayerNameContextFromSingleOrderLayout);
  if (!context) {
    throw new Error(
      "usePayerNameContextFromSingleOrderLayout must be used within a PayerNameContextFromSingleOrderLayoutProvider",
    );
  }
  return context;
};

export const PayerNameContextFromSingleOrderLayoutProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { singleMedicalPaOrder } = useSelector(
    (state: RootState) => state.singleMedicalPaOrder,
  );
  const payerName = singleMedicalPaOrder?.coverage?.primary?.payer_name ?? "";
  return (
    <PayerNameContextFromSingleOrderLayout.Provider
      value={{ payerName: payerName, setPayerName: () => {} }}
    >
      {children}
    </PayerNameContextFromSingleOrderLayout.Provider>
  );
};
